if (!customElements.get('cart-progress-bar')) {
  /* ------------------------------------------------------------------
     Confetti — zero dependency, single shared <canvas> on document.body
     (body par isliye taaki cart drawer ki overflow/transform se na kate)
  ------------------------------------------------------------------ */
  const Confetti = {
    canvas: null,
    ctx: null,
    particles: [],
    raf: null,
    colors: ['#f57c00', '#2e7d32', '#434e6e', '#ffc107', '#e91e63', '#26c6da'],

    ensureCanvas() {
      if (this.canvas) return;
      const c = document.createElement('canvas');
      c.setAttribute('aria-hidden', 'true');
      c.style.cssText =
        'position:fixed;top:0;left:0;pointer-events:none;z-index:2147483647;';
      document.body.appendChild(c);
      this.canvas = c;
      this.ctx = c.getContext('2d');
      this.resize();
      this._onResize = () => this.resize();
      window.addEventListener('resize', this._onResize);
    },

    resize() {
      const dpr = window.devicePixelRatio || 1;
      const w = window.innerWidth;
      const h = window.innerHeight;
      this.canvas.width = w * dpr;
      this.canvas.height = h * dpr;
      this.canvas.style.width = w + 'px';
      this.canvas.style.height = h + 'px';
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    },

    teardown() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this.canvas) this.canvas.remove();
      this.canvas = null;
      this.ctx = null;
      this.raf = null;
      this._onResize = null;
    },

    burst(x, y, opts = {}) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.ensureCanvas();

      const count = opts.count || 70;
      const power = opts.power || 9;
      const spread = opts.spread || 0.9; // 1 = ~180deg upward fan

      for (let i = 0; i < count; i++) {
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * spread;
        const speed = power * (0.4 + Math.random() * 0.6);
        this.particles.push({
          x,
          y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size: 4 + Math.random() * 5,
          color: this.colors[Math.floor(Math.random() * this.colors.length)],
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.35,
          life: 0,
          ttl: 70 + Math.random() * 45,
          round: Math.random() < 0.3
        });
      }

      if (!this.raf) this.raf = requestAnimationFrame(() => this.tick());
    },

    tick() {
      const ctx = this.ctx;
      if (!ctx) return;

      const w = window.innerWidth;
      const h = window.innerHeight;
      ctx.clearRect(0, 0, w, h);

      this.particles = this.particles.filter(
        (p) => p.life <= p.ttl && p.y < h + 60
      );

      this.particles.forEach((p) => {
        p.life++;
        p.vx *= 0.985;
        p.vy = p.vy * 0.985 + 0.22; // gravity
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - p.life / p.ttl);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.size / 2, -p.size / 3, p.size, p.size / 1.5);
        }
        ctx.restore();
      });

      if (this.particles.length) {
        this.raf = requestAnimationFrame(() => this.tick());
      } else {
        this.teardown();
      }
    }
  };

  class CartProgressBar extends HTMLElement {
    connectedCallback() {
      this.fillEl = this.querySelector('[data-cart-progress-fill]');
      this.textEl = this.querySelector('[data-cart-progress-text]');
      this.icons = this.querySelectorAll('.track-icon');

      // Milestones cart total ke bajaye journal quantity par based hain
      this.milestones = [
        { qty: 2, label: '5% off' },
        { qty: 3, label: '8% off' },
        { qty: 4, label: '12% off' }
      ];
      this.maxLabel = this.milestones[this.milestones.length - 1].label;

      const currentQty = parseInt(this.dataset.currentQuantity, 10) || 0;

      // window par store karo taaki drawer re-render hone par bhi pichli value yaad rahe
      const prevQty = window.__cartProgressPrev;
      window.__cartProgressPrev = currentQty;

      const isFirstLoad = typeof prevQty === 'undefined';
      const itemWasAdded = !isFirstLoad && currentQty > prevQty;
      const nextMilestone = this.getNextMilestone(currentQty);

      // Is update me jo milestones naye cross hue (ek saath 2 items add ho to
      // ek se zyada bhi ho sakte hain). First load par kabhi celebrate mat karo.
      const justUnlocked = isFirstLoad
        ? []
        : this.milestones.filter((m) => m.qty > prevQty && m.qty <= currentQty);

      if (justUnlocked.length) {
        // Milestone hit ho gaya — peek ki zaroorat nahi, seedha celebrate
        this.update(currentQty);
        this.celebrate(justUnlocked[justUnlocked.length - 1].qty);
      } else if (itemWasAdded && nextMilestone !== null) {
        this.peekThenSettle(currentQty, nextMilestone.qty);
      } else {
        this.update(currentQty);
      }
    }

    getNextMilestone(qty) {
      return this.milestones.find((m) => qty < m.qty) || null;
    }

    iconFor(milestoneQty) {
      return [...this.icons].find(
        (icon) => parseInt(icon.dataset.milestone, 10) === milestoneQty
      );
    }

    // 3 barabar segments: 2 items = 33%, 3 items = 66%, 4 items = 100%
    percentFor(qty) {
      if (qty <= 2) return (qty / 2) * 33;
      if (qty <= 3) return 33 + (qty - 2) * 33;
      if (qty <= 4) return 66 + (qty - 3) * 34;
      return 100;
    }

    /* ---------------- Celebration ---------------- */
    celebrate(milestoneQty) {
      const icon = this.iconFor(milestoneQty);
      const isFinal =
        milestoneQty === this.milestones[this.milestones.length - 1].qty;

      // Icon ka pop — reduced-motion me bhi safe hai (CSS me disable kiya hai)
      if (icon) {
        icon.classList.remove('track-icon--celebrate');
        void icon.offsetWidth; // reflow, taaki animation dobara chale
        icon.classList.add('track-icon--celebrate');
        icon.addEventListener(
          'animationend',
          () => icon.classList.remove('track-icon--celebrate'),
          { once: true }
        );
      }

      // Fill ko milestone tak pahunchne ka thoda time do, fir burst.
      // Rect timeout ke andar lete hain kyunki drawer abhi slide-in ho raha ho sakta hai.
      setTimeout(() => {
        const target = icon || this;
        const rect = target.getBoundingClientRect();
        if (!rect.width && !rect.height) return; // element hidden hai
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;

        Confetti.burst(x, y, {
          count: isFinal ? 110 : 65,
          power: isFinal ? 11 : 9,
          spread: isFinal ? 1.3 : 0.9
        });

        // Aakhri milestone par double burst
        if (isFinal) {
          setTimeout(
            () => Confetti.burst(x, y, { count: 80, power: 10, spread: 1.5 }),
            220
          );
        }
      }, 320);
    }

    peekThenSettle(actualQty, milestoneQty) {
      const peekPercent = this.percentFor(milestoneQty);
      const actualPercent = this.percentFor(actualQty);
      const milestoneIcon = this.iconFor(milestoneQty);

      // Text/icons ka lock-unlock state abhi actual value ke hisab se set kar do
      // (fill sirf peek ke liye alag se animate karenge)
      this.updateIconsAndText(actualQty);

      // Step 1: bar ko turant milestone tak udhaa do (pulsing band karke, taaki clash na ho)
      if (this.fillEl) {
        this.fillEl.classList.remove('progress-bar-fill--pulsing');
        this.fillEl.style.width = peekPercent + '%';
      }
      if (milestoneIcon) milestoneIcon.classList.add('track-icon--peek');

      // Step 2: thodi der ruko, fir wapas actual position par le aao aur continuous
      // pulse animation shuru kar do (jab tak agla milestone unlock na ho)
      setTimeout(() => {
        if (this.fillEl) this.fillEl.style.width = actualPercent + '%';
        if (milestoneIcon) milestoneIcon.classList.remove('track-icon--peek');
        this.startPulse(actualQty);
      }, 700);
    }

    updateIconsAndText(qty) {
      const nextMilestone = this.getNextMilestone(qty);

      this.icons.forEach((icon) => {
        const milestone = parseInt(icon.dataset.milestone, 10);
        const isUnlocked = qty >= milestone;
        icon.classList.toggle('track-icon--unlocked', isUnlocked);
        icon.classList.toggle(
          'track-icon--next',
          !isUnlocked && nextMilestone !== null && milestone === nextMilestone.qty
        );
      });

      if (!this.textEl) return;

      if (nextMilestone !== null) {
        const rem = nextMilestone.qty - qty;
        const noun = rem === 1 ? 'journal' : 'journals';
        this.textEl.innerHTML = `Add <strong>${rem} more ${noun}</strong> to unlock <strong>${nextMilestone.label}</strong>`;
      } else {
        this.textEl.innerHTML = `You've unlocked <strong>maximum savings ${this.maxLabel}</strong>`;
      }
    }

    // Fill ko actual value aur agle milestone ke beech continuously
    // (jaaye - wapas aaye - jaaye - wapas aaye...) pulse karwata hai.
    startPulse(qty) {
      if (!this.fillEl) return;
      const nextMilestone = this.getNextMilestone(qty);

      if (nextMilestone === null) {
        // Sab milestones unlock ho chuke — pulse band, bar 100% par settle
        this.fillEl.classList.remove('progress-bar-fill--pulsing');
        this.fillEl.style.width = this.percentFor(qty) + '%';
        return;
      }

      const actualPercent = this.percentFor(qty);
      const milestonePercent = this.percentFor(nextMilestone.qty);

      this.fillEl.style.setProperty('--fill-actual', actualPercent + '%');
      this.fillEl.style.setProperty('--fill-milestone', milestonePercent + '%');
      this.fillEl.style.width = '';
      this.fillEl.classList.add('progress-bar-fill--pulsing');
    }

    update(qty) {
      this.updateIconsAndText(qty);
      this.startPulse(qty);
    }
  }

  customElements.define('cart-progress-bar', CartProgressBar);
}